const Footer = {
    init() {
        const wechatAction = document.querySelectorAll( '[data-wechat-action]' );
        if ( wechatAction != null ) {
            [...wechatAction].forEach( el => {
                const qrCode = el.querySelector( '[data-wechat-qrcode]' );
                el.addEventListener( 'mouseenter', () => qrCode && qrCode.classList.remove( 'hidden' ) );
                el.addEventListener( 'mouseleave', () => qrCode && qrCode.classList.add( 'hidden' ) );
            } )
        }
    }
};

export default Footer;
